import { Component } from '@angular/core';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        //PrivacyPolicyComponent,
        CopyrightComponent
    ],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css'
})
export class FooterComponent {

  constructor(
    public router: Router,
  ) {
  }

}
